import React from "react"
import { Tooltip } from "antd"
import "./index.less"

interface ItemStatusProps {
  color: string
  backgroundColor: string
  classname?: string
  tooltip?: string
}

const ItemStatus: React.FC<ItemStatusProps> = ({
  color = "",
  backgroundColor = "",
  classname = "",
  tooltip,
}) => {
  const dot = (
    <span
      style={{
        width: "0.60rem",
        height: "0.60rem",
        borderRadius: "50%",
        backgroundColor: backgroundColor,
        border: `1px solid ${color}`,
        flexShrink: 0,
      }}
    />
  )

  return (
    <div className={`flex center-items gap-1 ${classname}`}>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <span className="inline-flex items-center skl-status-dot-trigger">{dot}</span>
        </Tooltip>
      ) : (
        dot
      )}
    </div>
  )
}

export default ItemStatus
